import * as types from '../types';

export const updatePreviousLocation = (location) => (dispatch) =>
	dispatch({
		type: types.UPDATE_PREVIOUS_LOCATION,
		payload: { location }
	});
